import { createUseStyles } from 'react-jss';

import { ITheme } from 'types';

const useStyles = createUseStyles((theme: ITheme) => ({
  fullWidth: {
    width: '100%',
  },
  cropSectionTitle: {
    fontSize: 12,
    lineHeight: 2.2,
    color: '#545869',
    margin: `${theme.spacings.s16} ${theme.spacings.s0} ${theme.spacings.s4} ${theme.spacings.s0}`,
    position: 'relative',
  },
  orientationItemContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridGap: 8,
  },
  cropSection: {
    '&:disabled': {
      cursor: 'no-drop',
      opacity: 0.4,
      backgroundColor: '#ffffff',
      '@media(hover: hover)': {
        '&:hover': {
          background: '#ffffff',
        },
      },
    },
    display: 'flex',
    justifyContent: 'center',
    height: 34,
    fontWeight: 600,
    padding: `10px ${theme.spacings.s0}`,
    borderRadius: theme.radiuses.r8,
    marginBottom: 8,
    '@media(hover: hover)': {
      '&:hover': {
        background: '#edeef499',
      },
    },
    fontSize: 12,
    lineHeight: 1.25,
    color: '#545869',
    cursor: 'pointer',
  },
  activeItem: {
    backgroundColor: '#edeef4',
    color: '#545869',
  },
  alignItemContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(6, 1fr)',
    gridGap: 4,
  },
  alignSection: {
    justifyContent: 'center',
    borderRadius: theme.radiuses.r8,
    height: 32,
    width: 32,
    '@media(hover: hover)': {
      '&:hover': {
        background: '#edeef499',
      },
    },
    cursor: 'pointer',
  },
  alignIcon: {
    width: 24,
    height: 24,
    '& path': {
      fill: '#626777',
    },
  },
}));

export default useStyles;
